import { render, staticRenderFns } from "./list_items.vue?vue&type=template&id=e767492e&scoped=true"
import script from "./list_items.vue?vue&type=script&lang=js"
export * from "./list_items.vue?vue&type=script&lang=js"
import style0 from "./list_items.vue?vue&type=style&index=0&id=e767492e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e767492e",
  null
  
)

export default component.exports